var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4728 34.4736L26.9455 36.001L30.0002 39.0557L31.5275 37.5283L43.5275 25.5283L45.0549 24.001L43.5275 22.4736L31.5275 10.4736L30.0002 8.94626L26.9455 12.001L28.4728 13.5283L36.7855 21.841L5.99997 21.841L3.83997 21.841L3.83997 26.161L5.99997 26.161L36.7855 26.161L28.4728 34.4736Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.34255f870fd49106fde34e16a1434228.svg";
export { ForwardRef as ReactComponent };